
const ArrowBack = (props) => {
  const { 
    fill="#2A8C89", 
  } = props;
  
  return (
    <svg 
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        stroke={fill}
        d="M7 15H11C13.7614 15 16 12.7614 16 10V10C16 7.23858 13.7614 5 11 5H3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path 
        stroke={fill}
        d="M5.11719 9L1.11719 5"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path 
        stroke={fill}
        d="M5.11719 1L1.11719 5"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
};

export default ArrowBack;
